// material-ui
import { useTheme } from "@mui/material/styles";
import { List, Typography } from "@mui/material";

// project imports
import NavItem from "../NavItem";
import NavCollapse from "../NavCollapse";

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

/**
 * A titled block of navigation rows.
 *
 * Groups are separated by their heading and by space, not by a rule: the old
 * `<Divider>` after every group drew five horizontal lines down a menu that is
 * already a single column.
 */
const NavGroup = ({ item }) => {
  const theme = useTheme();

  const items = item.children?.map((menu) => {
    if (!menu) {
      console.warn("Menu item is undefined", item);
      return false;
    }

    switch (menu.type) {
      case "collapse":
        return (
          <NavCollapse
            key={menu.id}
            menu={menu}
            level={1}
          />
        );
      case "item":
        return (
          <NavItem
            key={menu.id}
            item={menu}
            level={1}
          />
        );
      default:
        return (
          <Typography
            key={menu.id}
            variant="h6"
            color="error"
            align="center"
          >
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <List
      disablePadding
      sx={{ mb: 1 }}
      subheader={
        item.title && (
          <Typography
            sx={{ ...theme.typography.menuCaption }}
            display="block"
          >
            {item.title}
            {item.caption && (
              <Typography
                variant="caption"
                sx={{ ...theme.typography.subMenuCaption }}
                display="block"
              >
                {item.caption}
              </Typography>
            )}
          </Typography>
        )
      }
    >
      {items}
    </List>
  );
};

export default NavGroup;
